import crossDomainAuth from './crossDomainAuth';
import crossDomainInit from './crossDomainInit';

angular
    .module('signalview.crossdomain', ['sfx.security', 'signalboost'])
    .component('crossDomainAuth', crossDomainAuth)
    .component('crossDomainInit', crossDomainInit);
